import { ChatMessage } from "../../apis/chat.api";
import { FC } from "react";
import { motion } from "framer-motion";
import Markdown from "react-markdown";

interface MessageBubbleProps {
  message: ChatMessage;
}
export const CustomLink = ({
  href,
  children,
}: {
  href?: string;
  children?: React.ReactNode;
}) => (
  <a href={href} style={{ color: "blue", textDecoration: "underline" }}>
    {children}
  </a>
);

const MessageBubble: FC<MessageBubbleProps> = ({ message }) => {
  const isAgent = message.sender === "agent";

  if (message.isPending) {
    return (
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="bg-gray-100 rounded-lg py-2 px-4 flex justify-between w-[70px]"
      >
        <div className="w-2 h-2 rounded-full bg-gray-400 animate-pulse"></div>
        <div
          className="w-2 h-2 rounded-full bg-gray-400 animate-pulse"
          style={{ animationDelay: "0.2s" }}
        ></div>
        <div
          className="w-2 h-2 rounded-full bg-gray-400 animate-pulse"
          style={{ animationDelay: "0.4s" }}
        ></div>
      </motion.div>
    );
  }

  return (
    <motion.div
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className={`max-w-[312px] text-wrap text-[15px] break-words text-start p-4 rounded-[20px] font-medium ${
        message.sender === "user"
          ? "bg-blue-100 self-end"
          : "bg-white self-start"
      }`}
    >
      {!isAgent ? (
        message.message
      ) : (
        <Markdown
          components={{
            a: CustomLink,
          }}
        >
          {message.message}
        </Markdown>
      )}
    </motion.div>
  );
};
export default MessageBubble;
